import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const roadmapItems = [
  {
    quarter: 'Q4 2025',
    title: 'Tenant Screening',
    description: 'Credit, criminal, and eviction checks integrated seamlessly.',
    color: 'var(--primary)',
  },
  {
    quarter: 'Q1 2026',
    title: 'Rent Collection',
    description: 'ACH payments with automatic late fees and receipts.',
    color: 'var(--success)',
  },
  {
    quarter: 'Q2 2026',
    title: 'Property Manager API',
    description: 'White-label solution for PMs to generate leases at scale.',
    color: '#8B5CF6',
  },
  {
    quarter: 'Q3 2026',
    title: 'Commercial Leases',
    description: 'Expand to California commercial property leases.',
    color: '#F59E0B',
  },
];

const RoadmapSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 20, fontWeight: 700 }}>
          Coming Soon to TenantTerms
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: '1.2rem', marginBottom: 60 }}>
          We're just getting started. Here's what's on our roadmap:
        </p>
        <div className="features-grid">
          {roadmapItems.map((item, idx) => (
            <div 
              className="feature-card" 
              key={idx}
              style={{
                borderLeft: `4px solid ${item.color}`,
                textAlign: 'left',
                padding: '30px',
              }}
            >
              <div style={{ color: item.color, marginBottom: '10px', fontWeight: 600 }}>
                {item.quarter}
              </div>
              <h3 style={{ marginBottom: '15px', fontSize: '1.25rem', fontWeight: 600 }}>
                {item.title}
              </h3>
              <p style={{ color: 'var(--text-light)' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default RoadmapSection; 